import type { GreenhouseFlattenedJob, GreenhouseOfficeTree } from '../types';

export const flattenJobs = (
  officeTrees: GreenhouseOfficeTree[],
): GreenhouseFlattenedJob[] => {
  const flattenedJobs: GreenhouseFlattenedJob[] = [];

  const getJobsForOffice = (
    { children: childOffices, departments, ...office }: GreenhouseOfficeTree,
    officePath: number[],
  ) => {
    const currentOfficePath = [...officePath, office.id];

    flattenedJobs.push(
      ...departments.flatMap(({ jobs, ...department }) =>
        jobs.flatMap((job) => ({
          ...job,
          department,
          office,
          officePath: currentOfficePath,
        })),
      ),
    );

    childOffices.forEach((childOffice) => {
      getJobsForOffice(childOffice, currentOfficePath);
    });
  };

  officeTrees.forEach((officeTree) => getJobsForOffice(officeTree, []));

  return flattenedJobs;
};

export default flattenJobs;
